import { Box, Container } from '@material-ui/core'
import React from 'react'
import { Helmet } from 'react-helmet'
import Head from './Head'
import TableOrders from './TableOrders'
import TableProducts from './TableProducts'
import TableWithdraws from './TableWithdraws'
// import TableTransactions from './TableTransactions'

const DashboardAffiliate = () => (
  <Container>
    <Helmet>
      <title>{window.location.host} - Reseller Affiliate</title>
    </Helmet>
    <Box height={50} />
    <Head />
    <TableProducts />
    <TableOrders />
    <TableWithdraws />
    {/* <TableTransactions /> */}
  </Container>
)

export default DashboardAffiliate
